export const DEFAULT_SLIDER_SHORTCUT_BUTTONS_NL = {
  preflop: {
    btn1: "2BB",
    btn2: "3BB",
    btn3: "4BB",
    btn4: "All-In",
  },
  postflop: {
    btn1: "1/3 Pot",
    btn2: "1/2 Pot",
    btn3: "2/3 Pot",
    btn4: "All-In",
  },
};

export const DEFAULT_SLIDER_SHORTCUT_BUTTONS_PL = {
  preflop: {
    btn1: "2BB",
    btn2: "3BB",
    btn3: "4BB",
    btn4: "Pot",
  },
  postflop: {
    btn1: "1/3 Pot",
    btn2: "1/2 Pot",
    btn3: "2/3 Pot",
    btn4: "Pot",
  },
};
